import type { BenefitCode, InternalCookieOptions } from './types';
import { getExpiresInMonths, removeCookie, setCookie } from './utils';

const COOKIE_NAME = 'benefits';

/** Benefit program as returned by the benefits API. */
export interface BenefitProgram {
  code: string;
  benefits?: { code: string }[];
  organizationNumber?: string;
}

const toProgramCode = (code: string): BenefitCode =>
  code === 'F-1' ? 'FRAM' : `P${code}`;

const buildCookieValue = (programs: BenefitProgram[]): string =>
  programs
    .flatMap(({ code, benefits = [] }): BenefitCode[] => [
      toProgramCode(code),
      ...benefits.map(
        ({ code: benefitCode }): BenefitCode => `F${benefitCode}`,
      ),
    ])
    .join(',');

/** Sets or removes the `benefits` cookie from pre-fetched programs. */
export const writeBenefitCookie = (
  programs: BenefitProgram[],
  options: InternalCookieOptions,
): void => {
  if (programs.length) {
    setCookie(
      COOKIE_NAME,
      buildCookieValue(programs),
      options,
      getExpiresInMonths(1),
    );
  } else {
    removeCookie(COOKIE_NAME, options);
  }
};
